export const html = `<div>
<button className="px-4 py-1 bg-yellow-300 rounded-lg shadow-xl hover:text-white">
  Click me
</button>
</div>`;
